import { render } from "./DocumentEmail.vue?vue&type=template&id=679c0c30&scoped=true"
import script from "./DocumentEmail.vue?vue&type=script&lang=js"
export * from "./DocumentEmail.vue?vue&type=script&lang=js"

import "./DocumentEmail.vue?vue&type=style&index=0&id=679c0c30&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-679c0c30"]])

export default __exports__